import { DateInputControl } from '@sequencehq/core-components'
import { formatISODate } from '@sequencehq/utils'
import { useAtom } from 'jotai'
import { clientInvoiceAtom } from 'Invoices/atoms/invoiceEditing.atom'
import { FC } from 'react'
import { GreyGrey0 } from '@sequencehq/core-components'

type Props = {
  onChange?: (date: Date) => void
  inputWidth?: string
  'data-testid'?: string
  openOnMount?: boolean
}

export const CurrentInvoiceDatePicker: FC<Props> = ({
  onChange,
  inputWidth,
  'data-testid': dataTestId,
  openOnMount = false
}) => {
  const [clientInvoice, partialUpdateInvoice] = useAtom(clientInvoiceAtom)

  if (!clientInvoice) {
    return null
  }

  return (
    <DateInputControl
      inputProps={{
        height: '32px',
        _hover: {
          background: GreyGrey0
        },
        pl: '8px',
        fontSize: '13px',
        width: inputWidth,
        'data-testid': dataTestId
      }}
      value={
        clientInvoice.accountingDate
          ? new Date(clientInvoice.accountingDate)
          : new Date()
      }
      onChange={newDate => {
        if (newDate) {
          const accountingDate = formatISODate(newDate)

          // Payment terms re-derive from the new accounting date, so drop
          // the stale one. A manual date, or no policy, stays as it stands.
          partialUpdateInvoice({
            accountingDate,
            ...(clientInvoice.dueDatePolicy?.type === 'PAYMENT_TERMS' && {
              dueDate: undefined
            })
          })
          onChange?.(newDate)
        }
      }}
      minDate={null}
      maxDate={null}
      openOnMount={openOnMount}
    />
  )
}
